import React, { useState, useEffect, useRef } from "react";
import "./create.css";
import { getMyTeam } from "../../utils/playerSession";
import { useParams, useSearchParams } from "react-router-dom";

function Captain({ players, onSave, onBack, isEditing }) {
  const { id: matchId } = useParams(); // 139093
  const urlParams = new URLSearchParams(window.location.search);
  const teamId = urlParams.get("edit"); // 1

  const errorRef = useRef(null);
  const [captainId, setCaptainId] = useState(null);
  const [viceCaptainId, setViceCaptainId] = useState(null);
  const [teamName, setTeamName] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (isEditing) {
      const allTeams = getMyTeam() || [];
      console.log("akkkkk", allTeams);
      console.log("isEditing", teamId);

      //  Find correct team by matchId
      const existingTeam = allTeams?.find(
        (t) => String(t.Id) === String(teamId)
      );
      console.log("existingTeam", existingTeam);

      if (existingTeam) {
        setTeamName(existingTeam?.TeamName || "");
        setCaptainId(existingTeam?.CaptainId || null);
        setViceCaptainId(existingTeam?.ViceCaptainId || null);
      }
    } else {
      setTeamName("");
      setCaptainId(null);
      setViceCaptainId(null);
    }
    setError("");
  }, [matchId, teamId, isEditing]);

  const validateAndSave = () => {
    if (!teamName.trim()) {
      setError(" Team name is required.");
      return;
    }

    if (!captainId) {
      setError(" Please select a Captain.");
      return;
    }

    if (!viceCaptainId) {
      setError("Please select a Vice Captain.");
      return;
    }

    setError("");
    onSave(players, captainId, viceCaptainId, teamName);
  };

  useEffect(() => {
    if (error && errorRef.current) {
      errorRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center", // or "start",
      });
    }
  }, [error]);

  return (
    <div className="container-fluid mt-3 bg-black text-white p-3 rounded">
      <div className="text-center p-3 bg-dark rounded">
        <h5>Choose your Captain & Vice Captain</h5>
        <p className="small">C gets 2x points, VC gets 1.5x points</p>
      </div>

      <div className="mt-3">
        <label className="form-label">Team Name *</label>
        <input
          type="text"
          className="form-control"
          placeholder="Enter your team name"
          value={teamName}
          onChange={(e) => {
            setTeamName(e.target.value);
            setError("");
          }}
          maxLength={25}
        />
      </div>

      {/* ERROR MESSAGE */}
      {error && (
        <div
          ref={errorRef}
          className="alert alert-danger mt-2 p-2 text-center"
        >
          {error}
        </div>
      )}

      {/* PLAYER LIST */}
      <div className="mt-3">
        {players.map((p) => (
          <div
            key={p.id}
            className="d-flex justify-content-between align-items-center border border-secondary p-2 mb-2 rounded"
          >
            <span>{p.name}</span>
            <div>
              <button
                className={`btn btn-sm me-2 btn-captain ${captainId === p.id ? "active" : ""
                  }`}
                // onClick={() => setCaptainId(p.id)}
                onClick={() => {
                  if (viceCaptainId === p.id) {
                    setError("Player already selected as Vice Captain");
                    return;
                  }
                  setCaptainId(p.id);
                  setError("");
                }}
              >
                C
              </button>
              <button
                className={`btn btn-sm btn-vice ${viceCaptainId === p.id ? "active" : ""
                  }`}
                // onClick={() => setViceCaptainId(p.id)}
                onClick={() => {
                  if (captainId === p.id) {
                    setError("Player already selected as Captain");
                    return;
                  }
                  setViceCaptainId(p.id);
                  setError("");
                }}
              >
                VC
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* BOTTOM BUTTONS */}
      <div className="d-flex justify-content-between mt-4">
        <button className="btn btn-secondary" onClick={onBack}>
          Back
        </button>

        <button
          className="btn btn-success"
          onClick={validateAndSave}
        >
          Save Team
        </button>
      </div>
    </div>
  );
}

export default Captain;
